/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { jobsControllerCancel } from "./jobsControllerCancel";
import { jobsControllerCreate } from "./jobsControllerCreate";
import { jobsControllerFindAll } from "./jobsControllerFindAll";
import { jobsControllerFindOne } from "./jobsControllerFindOne";
import { jobsControllerGetOrgFairness } from "./jobsControllerGetOrgFairness";
import { jobsControllerGetQueueDepths } from "./jobsControllerGetQueueDepths";
import { jobsControllerRetriggerFile } from "./jobsControllerRetriggerFile";
import { jobsControllerRetry } from "./jobsControllerRetry";
import { jobsControllerUpdate } from "./jobsControllerUpdate";

export function jobsService() {
  return { jobsControllerFindAll, jobsControllerCreate, jobsControllerGetQueueDepths, jobsControllerGetOrgFairness, jobsControllerFindOne, jobsControllerUpdate, jobsControllerCancel, jobsControllerRetry, jobsControllerRetriggerFile }
}